export default __webpack_public_path__ + "static/media/createNewAppIcon.85fa0dcc.svg";